module.exports = __webpack_public_path__ + "static/media/add-site-white.700dbbd1.svg";